export default {
    errorFetchingFileMetaData: 'Error in fetching file meta data, please try again in little while',
    errorDownloadingDriveFile: 'error downloading your file, please try again',
}